<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" />
      </template>
    </template>
    <main class="common-main">
      <!-- 認証済みの時はメインの画面を表示 -->
      <template v-if="signedIn">
        <template v-if="isAdmin">
          <h2 class="common-title">管理ツール【社内限定】</h2>
          <h3 class="common-title">アカウント管理</h3>
          <div class="help">
            <dl class="item">
              <li><a href="/admin/userList">ユーザー一覧【開示先限定】</a></li>
              <li><a href="/admin/adviserList">アドバイザー一覧【開示先限定】</a></li>
            </dl>
          </div>
          <br>

          <h3 class="common-title">相談管理</h3>
          <div class="help">
            <dl class="item">
              <li><a href="/admin/counselingList">相談一覧【開示先限定】</a></li>
              <li><a href="/admin/counselingReplyList">相談返信一覧【開示先限定】</a></li>
            </dl>
          </div>
          <br>

          <h3 class="common-title">数値管理</h3>
          <div class="help">
            <dl class="item">
              <li><a href="/admin/insight">CancerWith Insight【社外秘】</a></li>
            </dl>
          </div>
          <br>

          <h3 class="common-title">環境情報</h3>
          <div class="text-box question-outerprofiletext">
            <ul>
              <li><b>環境</b>： {{env}}</li>
              <li><b>課金機能</b>： {{paymentActiveStatus}}</li>
              <li><b>Stripe用APIドメイン</b>： {{paymentApiDomain}}</li>
              <li><b>Stripe ベーシックプラン商品ID</b>： {{paymentBasicPlanPriceId}}</li>
              <li><b>公式テストアカウント</b>： {{officialTestAccount}}</li>
            </ul>
          </div>
        </template>
        <template v-else-if="isStaff">
          <dl class="item">
            管理者権限が必要です
          </dl>
        </template>
        <template v-else>
        </template>
      </template>

      <!-- 認証していない時はログイン画面を表示 -->
      <template v-else>
        <LoginItem :createButton="false" />
      </template>
    </main>
    <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { API, Auth, graphqlOperation, Analytics  } from 'aws-amplify'
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'

import { listStaffAllowListsBySpecificUser } from './graphql/queries'

import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

//const logger = new Logger('Admin');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'admin',
  components: {
    HeaderItem,
    FooterItem,
    LoginItem
  },
  mixins:[Common],
  data() {
    return {
      authState: undefined,
      unsubscribeAuth: undefined,
      id: '',
      mailaddress: '',
      signedIn: false,
      isStaff: false,
      isAdmin: false,
      contactUrl: '',
      userData: null,
      paymentActiveStatus: '',
      paymentApiDomain: '',
      paymentBasicPlanPriceId: '',
      officialTestAccount: '',
    }
  },
  
  methods: {
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });
    
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email

      let currentCredentials = await Auth.currentCredentials()
      this.identityId = currentCredentials.identityId
    } catch (err) {
      this.signedIn = false
    }

    // 運営アカウントか判定
    try {
      let staffAllowData = await API.graphql(
        graphqlOperation(listStaffAllowListsBySpecificUser, {
          mailAddress: this.mailaddress,
          limit: 1
        })
      )
      if (
        staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
        this.mailaddress
      ) {
        // 運営モード
        this.isStaff = true
        this.contactUrl = ''

        if (staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].isAdmin) {
          this.isAdmin = true
        } else {
          this.isAdmin = false
        }
      } else {
        this.isStaff = false
        this.isAdmin = false
        this.contactUrl = ''
        this.$router.push({ path: 'dashboard' })
      }
    } catch (err) {
      this.isStaff = false
      this.isAdmin = false
      this.contactUrl = ''
      this.$router.push({ path: '../dashboard' })    
    }

    this.env = this.getEnv(location.hostname)
    this.paymentActiveStatus = this.getPaymentActiveStatus(location.hostname)
    this.paymentApiDomain = this.getPaymentApiDomain(location.hostname)
    this.paymentBasicPlanPriceId = this.getPaymentBasicPlanPriceId(location.hostname)
    this.officialTestAccount = this.getOfficialTestAccount()

    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'Admin',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: ''
      }
    });

  }
}
</script>
<style>
</style>
<style src="./assets/style.css" />
